import * as React from 'react';
import { cn } from '@/lib/utils';

interface ProgressProps extends React.HTMLAttributes<HTMLDivElement> {
  value: number;
  totalSteps?: number;
  variant?: 'full' | 'step';
}

function Progress({
  value,
  totalSteps = 1,
  variant = 'full',
  className,
  ...props
}: ProgressProps) {
  if (variant === 'step') {
    return (
      <div className={cn('flex gap-2', className)} {...props}>
        {Array.from({ length: totalSteps }, (_, i) => {
          const step = i + 1;
          const isActive = step === value;
          const isCompleted = step < value;

          return (
            <div
              key={step}
              data-testid="step-segment"
              className={cn(
                'h-1.5 flex-1 rounded-full transition-colors duration-300',
                {
                  'bg-primary': isActive || isCompleted,
                  'bg-accent': step > value,
                }
              )}
            />
          );
        })}
      </div>
    );
  }

  // full (default) variant
  return (
    <div
      className={cn(
        'relative h-1.5 w-full overflow-hidden rounded-full bg-accent',
        className
      )}
      {...props}
    >
      <div
        role="progressbar"
        data-testid="progress-fill"
        className="h-full bg-primary transition-all duration-300"
        style={{ width: `${Math.min(value, 100)}%` }}
      />
    </div>
  );
}

export { Progress };
